export function progress (progress, element) {
    let elCancel = element.parentNode.querySelector('[data-role="cancel"]');
    if (elCancel) {
        elCancel.classList.remove('hidden');
    }

    let elDelete = element.parentNode.querySelector('[data-role="delete"]');
    if (elDelete) {
        elDelete.classList.add('hidden');
    }

    let elFileProgress = element.parentNode.querySelector('[data-role="fileprogress"]');
    if (elFileProgress) {
        elFileProgress.classList.remove('hidden');
        elFileProgress.innerHTML = progress + '%';
    }

    const elProgress = element.parentNode.querySelector('[data-role="progress"]');
    if (elProgress) {
        if (element.isImage) {
            elProgress.classList.add('opacity-75');
            elProgress.classList.remove('opacity-0');
        } else {
            elProgress.classList.remove('hidden');
        }
    }

    element.parentNode.querySelector('[data-role="fileprogressbar"]').classList.remove('hidden');
    element.parentNode.querySelector('[data-role="fileprogressbar"]').style.width = progress + '%';

    if (progress == 100) {
        if (elCancel) {
            elCancel.classList.add('hidden');
        }

        if (elDelete) {
            elDelete.classList.remove('hidden');
        }

        if (elFileProgress) {
            elFileProgress.classList.add('hidden');
        }

        if (element.isImage) {
            if (elProgress) {
                elProgress.classList.add('opacity-0');
                elProgress.classList.remove('opacity-75');
            }

            element.parentNode.querySelector('[data-role="fileprogressbar"]').classList.add('hidden');
        }

        element.source = false;
    }
}

export function upload(data, progressCallback, source)
{
    const config = {
        onUploadProgress: progressCallback ? function(progressEvent) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            progressCallback(percentCompleted);
        } : null,
        cancelToken: source ? source.token : null
    }

    return axios.post(Jobtoolz.api.url + '/content/v1/file', data, config)
        .then(response => {
            return response.data;
        });
}

export function resetDragDropClasses(element)
{
    //element.querySelector('[data-role="fileprogressbar"]').style.width = '0';

    element.querySelector('[data-svg="default"]').classList.remove('hidden');
    element.querySelector('[data-svg="forbidden"]').classList.add('hidden');

    if (element.querySelector('[type="file"]').isImage) {
        element.querySelector('[data-role="progress"]').classList.add('opacity-0');
        element.querySelector('[data-role="progress"]').classList.remove('opacity-75');
        element.querySelector('[data-role="fileprogressbar"]').classList.add('hidden');
    } else {
        element.classList.add('border-primary-20');
        element.classList.remove('border-secondary', 'bg-secondary-5', 'border-semantic-error', 'bg-semantic-error-light');
    }
}

export function validateUploadedItems(event, isImage)
{
    let files = (typeof event.dataTransfer == 'undefined')
        ? event.target.files
        : ( event.dataTransfer.items || [] );

    if (files.length != 1) {
        return false;
    }

    if (isImage) {
        let valid = true;

        for (let i = 0; i < files.length; i++) {

            let item = files.item(i);

            if (!item.type.match(/image\//)) {
                valid = false;
            }
        }

        return valid;
    }

    return true;
}
